<template>
    <div>
        <!--<template v-if="!isMediaTop">-->
        <!--&lt;!&ndash; 타이틀 &ndash;&gt;-->
        <!--<slot></slot>-->
        <!--<div v-for="each, i in contentsArr" :key="i" class="margin_top" style="padding:0px 20px;" :style="{ padding: isContentsPadding ? '0px 20px' : '' }">-->
        <!--<div v-if="each && each.indexOf('https://youtu.be/') === -1 && each.indexOf('https://www.youtube.com/shorts/') === -1 && each.indexOf('https://youtube.com/shorts/') === -1" style="line-height:22px; white-space:pre-wrap;" :style="{ fontSize: contentsFontSize }">{{ each }}</div>-->
        <!--</div>-->
        <!--</template>-->
        <template v-for="each, i in contentsArr">
            <div v-if="each" :key="'you' + i" class="margin_top">
                <div :style="{ paddingBottom: paddingBottom }" v-if="true" class="video-container">
                    <div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>
                    <iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="getYouTubeEmbedUrl(each)" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">
                    </iframe>
                </div>
                <!--<div v-else-if="each && each.indexOf('https://www.youtube.com/shorts/') > -1" class="video-container">-->
                    <!--<div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9999; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>-->
                    <!--<iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="'https://www.youtube.com/embed/' + each.replace('https://www.youtube.com/shorts/', '')" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">-->
                    <!--</iframe>-->
                <!--</div>-->
                <!--<div v-else-if="each && each.indexOf('https://youtube.com/shorts/') > -1" class="video-container">-->
                    <!--<div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9999; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>-->
                    <!--<iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="'https://www.youtube.com/embed/' + each.replace('https://youtube.com/shorts/', '')" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">-->
                    <!--</iframe>-->
                <!--</div>-->
                <!--<div v-else-if="each && each.indexOf('https://www.youtube.com/watch?v=') > -1" class="video-container">-->
                    <!--<div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9999; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>-->
                    <!--<iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="'https://www.youtube.com/embed/' + each.replace('https://www.youtube.com/watch?v=', '')" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">-->
                    <!--</iframe>-->
                <!--</div>-->
                <!--<div v-else-if="each && each.indexOf('https://www.youtube.com/watch?v=') > -1" class="video-container">-->
                    <!--<div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9999; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>-->
                    <!--<iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="'https://www.youtube.com/embed/' + each.replace('https://www.youtube.com/watch?v=', '')" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">-->
                    <!--</iframe>-->
                <!--</div>-->
                <!--<div v-else-if="each && each.indexOf('https://www.youtube.com/live/') > -1" class="video-container">-->
                    <!--<div @click.stop="setVideo(each, i)" style="position: absolute; z-index: 9999; background-color: transparent; width: 100%; height: 49%; top: 50%; transform: translateY(-63%);"></div>-->
                    <!--<iframe ref="youtubeIframe" :id="'youtubePlayer_' + randomNum" :src="'https://www.youtube.com/embed/' + each.replace('https://www.youtube.com/live/', '') + '?enablejsapi=1&playsinline=0'" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">-->
                    <!--</iframe>-->
                <!--</div>-->
            </div>
        </template>

        <!-- 타이틀 -->
        <!--<template v-if="isMediaTop">-->
        <!--<slot></slot>-->
        <!--<div v-for="each, i in contentsArr" :key="i" class="margin_top" style="padding:0px 20px;" :style="{ padding: isContentsPadding ? '0px 20px' : '' }">-->
        <!--<div v-if="each && (each.indexOf('https://youtu.be/') === -1 && each.indexOf('https://www.youtube.com/shorts/') === -1 && each.indexOf('https://youtube.com/shorts/') === -1)" style="line-height:23px; white-space:pre-wrap;" :style="{ fontSize: contentsFontSize }">{{ each }}</div>-->
        <!--</div>-->
        <!--</template>-->

    </div>
</template>

<script>
export default {
    name: "ContentsViewer",
    props: {
        contents: {
            type: String,
            default: '',
        },
        isContentsPadding: {
            type: Boolean,
            default: true
        },
        contentsFontSize: {
            type: String,
            default: '16px'
        },
        isMediaTop: {
            type: Boolean,
            default: true,
        },
        paddingBottom: {
            type: String,
            default: '56.25%'
        },
        pageType: {
            type: String,
            default: ''
        },
        isFromHome: {
            type: Boolean,
            default: false
        }

    },
    mounted() {
        const random = Math.random()
        this.randomNum = random
        const device = this.$cookies.get('device');
        this.device = device
    },
    computed: {
        contentsArr() {
            const pattern = /(https?:\/\/\S+\r?\n?)/gis;
            const result = this.contents.split(pattern);

            return result;
        },
        isYouTubeAPILoaded() {
            if (window.YT && window.YT.Player) {
                return true
            } else {
                return false
            }
        }
    },
    data() {
        return {
            players: {},
            randomNum: null,
            device: null
        }
    },
    methods: {
        setVideo(path, i) {
            if (this.isFromHome && this.pageType === 'interview') {
                this.$Util.sendEventClick('홈_하단_스포트라이트_인터뷰시청_횟수', true)
            } else if (!this.isFromHome && this.pageType === 'soccer_team') {
                this.$Util.sendEventClick('축구팀_상세_인터뷰시청_횟수', true)
            }
            if (this.device === 'ios') {
                this.playVideo(i)
            } else {
                this.$GlobalStore.addModal('VideoViewer', { urlPath: path, isYoutube: true, status_bar_text_color: 'white' })
            }
        },
        getYouTubeEmbedUrl(url) {
            let replace_url = '';
            if (url.includes('https://youtu.be/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtu.be/', '')}`;
            } else if (url.includes('https://www.youtube.com/shorts/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/shorts/', '')}`;
            } else if (url.includes('https://youtube.com/shorts/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtube.com/shorts/', '')}`;
            } else if (url.includes('https://www.youtube.com/watch?v=')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/watch?v=', '')}`;
                replace_url = replace_url.replace('&', '?');
            } else if (url.includes('https://youtube.com/watch?v=')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtube.com/watch?v=', '')}`;
                replace_url = replace_url.replace('&', '?');
            } else if (url.includes('https://www.youtube.com/live/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/live/', '')}`;
            }

            replace_url += replace_url.includes('?') ? '&enablejsapi=1&playsinline=0' : '?enablejsapi=1&playsinline=0';

            return replace_url;
        },
        isYouTubeLink(url) {
            return url.includes('https://youtu.be/') || url.includes('https://www.youtube.com/shorts/') || url.includes('https://youtube.com/shorts/') || url.includes('https://www.youtube.com/watch?v=');
        },
        async playVideo(index) {

            if (!this.isYouTubeAPILoaded) {
                return;
            }

            // const iframe = this.$refs.youtubeIframe

            // if (iframe[0].requestFullscreen) {
            //     await iframe[0].requestFullscreen();
            // } else if (iframe[0].webkitRequestFullscreen) {
            //     await iframe[0].webkitRequestFullscreen();
            // } else if (iframe[0].mozRequestFullScreen) {
            //     await iframe[0].mozRequestFullScreen();
            // } else if (iframe[0].msRequestFullscreen) {
            //     await iframe[0].msRequestFullscreen();
            // }

            /*eslint-disable no-undef */
            this.$nextTick(() => {
                if (!this.players[index]) { // 플레이어가 없으면 새로 생성
                    this.players[index] = new YT.Player(`youtubePlayer_${this.randomNum}`, {
                        events: {
                            "onReady": (event) => event.target.playVideo(),
                        }
                    });
                } else {
                    try {
                        const playerState = this.players[index].getPlayerState();

                        if (playerState === YT.PlayerState.PLAYING) {
                            this.pauseVideo(index);
                        } else {
                            this.players[index].playVideo();
                        }
                    } catch (error) {
                        console.error("YouTube Player 에러:", error);
                    }
                }
            })
        },
        pauseVideo(index) {
            if (this.players[index]) {
                this.players[index].pauseVideo();
            }
        },

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.margin_top+.margin_top {
    margin-top: 3px;
}

.video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0px;
    height: 0;
    overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>